import { render } from "./ArchMirrorPage.vue?vue&type=template&id=2ac2a7d7"
import script from "./ArchMirrorPage.vue?vue&type=script&lang=js"
export * from "./ArchMirrorPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__